import React from 'react';
import './index.scss';
import OptionalIcon from '../../atoms/Icon/OptionalIcon';

const PcInputLine = ({ title, children, optional = false }) =>{
  const DispTitle = () => {
    return Array.isArray(title) 
      ? title.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{title}</>;
  };

  return (
    <div className="PcInputLine">
      <span className="PIA-title"> 
        <DispTitle />
        {optional && <OptionalIcon /> }
      </span>
      <span className="PIA-item">
        {children}
      </span>
    </div>
  );
};

export default PcInputLine;